import type { AdElement } from '@adflow/types';

export const RIGHT_SIDEBAR_WIDTH_CSS = 'clamp(350px, 25vw, 450px)';

/** Store slice needed to know whether {@link RIGHT_SIDEBAR_WIDTH_CSS} is visible on screen. */
export type RightSidebarOpenState = {
  elements: AdElement[];
  selectedElementIds: readonly string[];
  selectedElementId: string | null;
};

/**
 * True when the right sidebar renders (multi-select summary or single-element panel).
 * Keep preview inset, canvas controls, and {@link Rightsidebar} aligned on this predicate.
 */
export const isRightSidebarOpen = (state: RightSidebarOpenState): boolean => {
  if (state.selectedElementIds.length > 1) {
    return true;
  }
  if (state.selectedElementId == null) {
    return false;
  }
  return state.elements.some((element) => element.id === state.selectedElementId);
};
